var map = {
	"./deeppharma-bw.png": 2272,
	"./meringer-bw.png": 3792,
	"./miralex-bw.png": 4447,
	"./novartis-bw.png": 1519,
	"./ppoint-bw.png": 6353,
	"./refwell-logo.svg": 4665,
	"./refwell_mobile_logo.png": 9301,
	"./sequoia-bw.png": 3686,
	"img/rw-logos/deeppharma-bw.png": 2272,
	"img/rw-logos/meringer-bw.png": 3792,
	"img/rw-logos/miralex-bw.png": 4447,
	"img/rw-logos/novartis-bw.png": 1519,
	"img/rw-logos/ppoint-bw.png": 6353,
	"img/rw-logos/refwell-logo.svg": 4665,
	"img/rw-logos/refwell_mobile_logo.png": 9301,
	"img/rw-logos/sequoia-bw.png": 3686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2414;